import { type FC } from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import ModerationAlert from '@wix/da-ds/pkg/Icons/16x16/ModerationAlert';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { Url } from '@wix/da-url';

import s from './VideoCreatorModeration.scss';

const llamaUrl = Url.staticCDNLink('video_generator/llama_grayscale.png');

export interface Props {
  className?: string;
  companyName: string;
}

const VideoCreatorModeration: FC<Props> = ({ className, companyName }) => {
  const { t } = useTranslation();

  return (
    <div className={cn(s['root'], className)}>
      <div className={s['llama-part']}>
        <img
          className={s['llama-icon']}
          src={llamaUrl}
          alt={t('studio.videoCreator.results.emptyPlaceholder.altText')}
        />
        <Heading className={s['llama-heading']}>
          <ModerationAlert className={s['alert-icon']} size={IconSize.SMALL} />
          {t('studio.videoCreator.results.moderation.header', {
            postProcess: 'reactPostprocessor',
            moderationCompany: `${companyName}`,
          })}
        </Heading>
        <div className={s['llama-text']}>
          {t('studio.videoCreator.results.moderation.detail')}
        </div>
      </div>
    </div>
  );
};

VideoCreatorModeration.displayName = 'VideoCreatorModeration';
export default VideoCreatorModeration;
